import * as types from '../mutations'
import LocationService from '@/services/LocationService'

const state = {
  selectedFarm: {},
  farms: [],
  filteredFarms: [],
  count: 0,
  processor: {},
  processors: [],
  packagingPlant: {},
  loading: true
}

const getters = {
  selectedFarm: (state) => state.selectedFarm,
  farms: (state) => state.farms,
  farmCount: (state) => state.count,
  filteredFarms: (state) => state.filteredFarms,
  farmLoading: (state) => state.loading,
  processor: (state) => state.processor,
  processors: (state) => state.processors,
  packagingPlant: (state) => state.packagingPlant,

  getProcessor: (state) => (processorId) => {
    if (!state.processors.length) {
      return {}
    }

    return state.processors.find((processor) => {
      return processor.owner === processorId
    })
  },

  getFarm: (state) => (locationId) => {
    if (!state.farms.length) {
      return {}
    }

    return state.farms.find((farm) => {
      return farm.id === locationId
    })
  }
}

const actions = {

  selectFarm ({ commit }, { farm }) {
    commit(types.SELECT_FARM, farm)
  },

  clearFarmSelection ({ commit }) {
    commit(types.CLEAR_FARM_SELECTION)
  },

  async searchFarm ({ commit }, search) {
    commit(types.FARM_LOADING)
    let data = await LocationService.loadFarms(search)
    commit(types.SET_FILTERED_FARM_LIST, data)
    commit(types.FARM_LOADED)
  },

  async loadFarmList ({ commit }) {
    commit(types.FARM_LOADING)
    let data = await LocationService.loadFarms()
    commit(types.SET_FARM_LIST, data)
    commit(types.SET_FILTERED_FARM_LIST, data)
    commit(types.FARM_LOADED)
  },

  async updateFarm ({ commit, dispatch }, { farm }) {
    let res = await LocationService.updateFarm(farm)
    commit(types.FARM_UPDATED, res)
    dispatch('selectFarm', { farm })
    return Promise.resolve(res.id)
  },

  async createFarm ({ commit }, { farm }) {
    let res = await LocationService.createFarm(farm)
    commit(types.FARM_CREATED, res)
    return Promise.resolve(res.id)
  },

  async loadProcessor ({ commit }, { owner }) {
    let processors = await LocationService.loadProcessors(owner)
    commit(types.SET_PROCESSOR, processors[0])
  },

  async loadProcessors ({ commit }) {
    let processors = await LocationService.loadProcessors()
    commit(types.SET_PROCESSORS, processors)
  },

  async loadPackagingPlant ({ commit }) {
    let plants = await LocationService.loadPackagingPlant()
    commit(types.SET_PACKAGING_PLANT, plants[0])
  }

}

const mutations = {

  [types.SELECT_FARM] (state, farm) {
    state.selectedFarm = farm
  },

  [types.CLEAR_FARM_SELECTION] (state) {
    state.selectedFarm = {}
  },

  [types.SET_FARM_LIST] (state, data) {
    state.farms = data.results
  },

  [types.SET_FILTERED_FARM_LIST] (state, data) {
    state.filteredFarms = data.results
    state.count = data.count
  },

  [types.FARM_LOADING] (state) {
    state.loading = true
  },

  [types.FARM_LOADED] (state) {
    state.loading = false
  },

  [types.FARM_CREATED] (state, farm) {
    state.farms.unshift(farm)
  },

  [types.FARM_UPDATED] (state, farm) {
    state.farms = [
      ...state.farms.filter(f => f.id !== farm.id),
      farm
    ]
  },

  [types.SET_PROCESSOR] (state, processor) {
    state.processor = processor
  },

  [types.SET_PROCESSORS] (state, processors) {
    state.processors = processors
  },

  [types.SET_PACKAGING_PLANT] (state, plant) {
    state.packagingPlant = plant
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
